import React from 'react'
import clsx from 'clsx'
import CheckIcon from '@/assets/icons/check-thin-white.svg'
import { CheckboxProps } from '@/components/atoms/Checkbox/types'

export function Checkbox({ name, onChange, checked, className, required, ...rest }: CheckboxProps) {
  return (
    <label
      className={clsx(
        'w-32 h-32 border-1 border-grey-100 rounded flex justify-center items-center flex-shrink-0 focus-within:outline-1 focus-within:outline-primary-500 focus-within:ring-2 focus-within:ring-primary-500 focus:border-transparent',
        checked && 'bg-primary-500',
        className
      )}
      htmlFor={name}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        required={required}
        {...rest}
        className="absolute -z-1"
      />
      {checked && <img src={CheckIcon} alt={name} />}
    </label>
  )
}
